export const UNRESOLVED_ORDERS_TABLE_SETTINGS = {
    OVERSCAN_ROW_COUNT: 15
}